import React from 'react';
import { SvgIcon } from '@mui/material';

const SvgVideoTourOutline = (props) => (
  <SvgIcon {...props} title="VideoTourOutline">
    <svg
      viewBox="0 0 16 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.3 1.667c.11 0 .2.09.2.2v6.266a.2.2 0 0 1-.2.2H2.367a.2.2 0 0 1-.2-.2V1.867c0-.11.09-.2.2-.2H10.3ZM11.333 0h-10A.836.836 0 0 0 .5.833v8.334c0 .458.375.833.833.833h10a.836.836 0 0 0 .834-.833V6.25l1.626 1.626c.63.63 1.707.184 1.707-.707V2.831c0-.891-1.077-1.337-1.707-.707L12.167 3.75V.833A.836.836 0 0 0 11.333 0Z"
        fill={props.fill}
      />
    </svg>
  </SvgIcon>
);

export default SvgVideoTourOutline;
